import { Button } from "antd";
import { LeftOutlined } from "@ant-design/icons";

const BackButton = ({ className = "", onClick = null }) => {
  return (
    <Button
      type="text"
      icon={<LeftOutlined />}
      style={{ fontSize: "20px" }}
      className={`back-button ${className}`}
      onClick={onClick}
      shape="round"
    />
  );
};

export default BackButton;
